// External libraries
import React from 'react';
import { useTheme } from 'emotion-theming';
// @ts-expect-error TODO: type or globally ignore react-components
import { Interstitial as InterstitialModal } from '@checkout/react-components';

// Internal modules
import { features, useCookieBannerHeight } from '@/lib';
import {
  getButtonStylesOverrides,
  getHeaderStyleOverrides,
  getInterstitialStyleOverrides,
  getOverlayStyleOverrides,
} from './styles';
import { CloseSmIcon } from '@/components/Common';

interface InterstitialProps {
  isLoading?: boolean;
  mobileQueryWidth?: number;
  //index signature to make sure we typed the ...rest props
  [x: string]: any;
}

export const Interstitial: React.FC<InterstitialProps> = ({
  children,
  isLoading,
  mobileQueryWidth = 420,
  ...interstitialProps
}) => {
  const cookieBannerHeight = useCookieBannerHeight();
  const isWPS = features.isActive('isWps');
  const isForcedGuest = features.allActive('isForcedGuest');
  const theme: AppTheme.WeasleyTheme = useTheme();

  return (
    <InterstitialModal
      headerStyleOverrides={getHeaderStyleOverrides({
        isFullScreenModal: isWPS,
        isLoading,
      })}
      interstitialStyleOverrides={getInterstitialStyleOverrides({
        cookieBannerHeight,
        isForcedGuest,
        isFullScreenModal: isWPS,
        mobileQueryWidth,
        ...interstitialProps,
      })}
      overlayStyleOverrides={getOverlayStyleOverrides(mobileQueryWidth)}
      closeButtonStyleOverrides={getButtonStylesOverrides({
        isFullScreenModal: isWPS,
        theme,
      })}
      closeButtonContent={<CloseSmIcon />}
      {...interstitialProps}
    >
      {children}
    </InterstitialModal>
  );
};

export default Interstitial;
